import { Flex, styled, StyleSystemProps } from '@withjoy/joykit';

export const StyledRoot = styled(Flex)``;
const rootStyles: StyleSystemProps = {
  flexDirection: 'column',
  alignItems: 'center',
  position: 'relative',
  rowGap: ['1.5rem', '3rem'],
};

export const styles = {
  root: rootStyles,
};
